/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";

const DefaultAddDocumentButtonComponent = (props) => {
    
    const { t } = useTranslation();
    const { setOpen } = props;
    
    const openDocumentDialog = () => {
        setOpen(true);
    };
    
    return (
        <Fragment>
            <div className='default-add-document-button-container'>
                <Button
                    color='primary'
                    variant='contained'
                    onClick={openDocumentDialog}
                >
                    <SVGIcons.common.Create sx={{ marginRight: "8px" }} /> {t("commons.selectDocument")}
                </Button>
            </div>
        </Fragment>
    );
};

export { DefaultAddDocumentButtonComponent };
